<script>
  import { suggestions, sendMessage } from '../stores/chatStore.js';

  export let onSuggestionClick = null;

  function handleChipClick(suggestion) {
    if (onSuggestionClick) {
      onSuggestionClick(suggestion);
    } else {
      sendMessage(suggestion);
    }
  }
</script>

{#if $suggestions && $suggestions.length > 0}
  <div class="suggestions-container">
    <div class="suggestions-scroll">
      {#each $suggestions as suggestion}
        <button 
          class="suggestion-chip"
          on:click={() => handleChipClick(suggestion)}
          type="button"
        >
          {typeof suggestion === 'string' ? suggestion : JSON.stringify(suggestion)}
        </button>
      {/each}
    </div>
  </div>
{/if}

<style>
  .suggestions-container {
    width: 100%;
    margin-bottom: 12px;
    overflow: hidden;
  }

  .suggestions-scroll {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding: 4px 0;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  }

  .suggestions-scroll::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  .suggestion-chip {
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    padding: 8px 16px;
    color: #e5e7eb;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    backdrop-filter: blur(10px);
  }

  .suggestion-chip:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  .suggestion-chip:active {
    transform: translateY(0);
    background: rgba(255, 255, 255, 0.2);
  }

  .suggestion-chip:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
  }

  /* Smooth scroll behavior */
  .suggestions-scroll {
    scroll-behavior: smooth;
  }

  /* Add fade effect at edges */
  .suggestions-container::before,
  .suggestions-container::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 20px;
    pointer-events: none;
    z-index: 1;
  }

  .suggestions-container {
    position: relative;
  }

  .suggestions-container::before {
    left: 0;
    background: linear-gradient(to right, rgba(17, 24, 39, 1), transparent);
  }

  .suggestions-container::after {
    right: 0;
    background: linear-gradient(to left, rgba(17, 24, 39, 1), transparent);
  }

  /* Animation for new suggestions */
  .suggestion-chip {
    animation: slideIn 0.3s ease-out;
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
